import React, { Component } from 'react';
import { Select } from 'antd';
import { groupBy, forEach, filter } from 'lodash';
import { connect } from 'react-redux';

import { StyledSelect } from 'components/Styled';

const { Option, OptGroup } = Select;

class AreaSelect extends Component {
  generateOptions = () => {
    const districtDisplay = {
      'Hong Kong Island': '香港島',
      Kowloon: '九龍',
      'New Territories': '新界'
    };

    let elements = [];

    const districtList = ['Hong Kong Island', 'Kowloon', 'New Territories'];

    const areas = filter(this.props.areas, ['parent', null]);
    const groupedAreas = groupBy(areas, 'district');

    forEach(districtList, district => {
      if (!groupedAreas[district]) {
        return;
      }

      let subList = groupedAreas[district];

      elements.push(
        <OptGroup
          key={district}
          label={
            this.props.t('key') === 'en' ? district : districtDisplay[district]
          }>
          {subList.map(area => (
            <Option value={area.name.en} key={area.slug}>
              {area.name[this.props.t('key')]}
            </Option>
          ))}
        </OptGroup>
      );
    });

    return elements;
  };

  render() {
    return (
      <StyledSelect
        size="large"
        placeholder={this.props.t('common.select')}
        value={this.props.value || undefined}
        onChange={this.props.onChange}
        onBlur={this.props.onBlur}>
        {this.generateOptions()}
      </StyledSelect>
    );
  }
}

const mapStateToProps = state => {
  return {
    areas: state.shipments.areas
  };
};

export default connect(mapStateToProps)(AreaSelect);
